// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Root Layout — Three Column ===== */
.app-layout {
  display: flex;
  height: 100%;
  overflow: hidden;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: var(--font-family);
  /* Safe-area horizontal insets for iPad landscape / iPhone notched landscape */
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

/* ===== Nav Rail (Column 1) ===== */
.nav-rail {
  width: 56px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--bg-base);
  border-right: 1px solid var(--glass-border);
  /* Safe-area top/bottom (status bar / home indicator) padded into the rail
     so nav buttons never collide with system overlays on iPad/iPhone. */
  padding-top: max(var(--spacing-sm), env(safe-area-inset-top));
  padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));
  z-index: 2;
}

.nav-rail-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex: 1;
  padding-top: var(--spacing-sm);
}

.nav-rail-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: var(--spacing-sm);
}

.nav-btn {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  border-radius: var(--radius-md);
  color: var(--text-tertiary);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.nav-btn:hover {
  color: var(--text-secondary);
  background: var(--bg-hover);
}

.nav-btn-active {
  color: var(--color-primary);
  background: var(--color-primary-dim);
}

.nav-btn-active::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  background: var(--color-primary);
  border-radius: 0 var(--radius-xs) var(--radius-xs) 0;
}

/* Profile avatar in nav rail */
.nav-avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-fast);
  border: 2px solid transparent;
  object-fit: cover;
}

.nav-avatar:hover {
  border-color: var(--glass-highlight);
}

.nav-avatar-active {
  border-color: var(--color-primary);
}

.nav-avatar-initials {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  color: white;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-fast);
  border: 2px solid transparent;
}

.nav-avatar-initials:hover {
  border-color: var(--glass-highlight);
}

.nav-avatar-initials.nav-avatar-active {
  border-color: var(--color-primary);
  box-shadow: 0 0 8px var(--color-primary-glow);
}

/* ===== List Panel (Column 2) ===== */
.list-panel {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: var(--bg-elevated);
  border-right: 1px solid var(--glass-border);
  overflow: hidden;
}

.list-panel-header {
  flex-shrink: 0;
  padding: var(--spacing-md) var(--spacing-md) var(--spacing-sm);
}

.list-panel-title {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  letter-spacing: var(--letter-spacing-tight);
}

.list-panel-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Scrollbar */
.list-panel-content::-webkit-scrollbar {
  width: 4px;
}

.list-panel-content::-webkit-scrollbar-track {
  background: transparent;
}

.list-panel-content::-webkit-scrollbar-thumb {
  background: var(--glass-border);
  border-radius: var(--radius-full);
}

.list-panel-content::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}

/* ===== Main Panel (Column 3) ===== */
.app-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .app-layout {
    position: relative;
  }

  .nav-rail {
    display: none;
  }

  .list-panel {
    width: 100%;
    position: absolute;
    inset: 0;
    z-index: 10;
    transform: translateX(0);
    transition: transform 0.3s var(--ease-out-expo);
  }

  .list-panel.list-panel-hidden {
    transform: translateX(-100%);
    pointer-events: none;
  }

  .app-main {
    width: 100%;
    position: absolute;
    inset: 0;
    transform: translateX(0);
    transition: transform 0.3s var(--ease-out-expo);
  }

  .app-main.app-main-hidden {
    transform: translateX(100%);
    pointer-events: none;
  }
}

/* ===== iPad / Tablet (>= 768px) =====
   Explicit min-width breakpoint complements the max-width: 768 mobile branch.
   Three-column layout is the default flex behaviour; this rule re-asserts it
   for tablets that the max-width rule otherwise wouldn't reach (e.g. iPad
   portrait at ~820dp, landscape ~1180dp, Stage Manager free windows). */
@media (min-width: 768px) {
  .app-layout {
    position: static;
  }

  .nav-rail {
    display: flex;
  }

  .list-panel {
    position: static;
    inset: auto;
    transform: none;
    transition: none;
    z-index: auto;
  }

  .list-panel.list-panel-hidden {
    /* On tablets we keep the list panel docked rather than slid off-screen. */
    transform: none;
    pointer-events: auto;
  }

  .app-main {
    position: static;
    inset: auto;
    transform: none;
    transition: none;
  }

  .app-main.app-main-hidden {
    transform: none;
    pointer-events: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/AppLayout.css"],"names":[],"mappings":"AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,8EAA8E;EAC9E,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,2CAA2C;EAC3C;wEACsE;EACtE,6DAA6D;EAC7D,mEAAmE;EACnE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,sCAAsC;EACtC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iFAAiF;EACjF,YAAY;EACZ,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8DAA8D;AAChE;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,wBAAwB;IACxB,+CAA+C;EACjD;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,+CAA+C;EACjD;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;;AAEA;;;;wEAIwE;AACxE;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,0EAA0E;IAC1E,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF","sourcesContent":["@import \"../styles/variables.css\";\n\n/* ===== Root Layout — Three Column ===== */\n.app-layout {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: var(--font-family);\n  /* Safe-area horizontal insets for iPad landscape / iPhone notched landscape */\n  padding-left: env(safe-area-inset-left);\n  padding-right: env(safe-area-inset-right);\n}\n\n/* ===== Nav Rail (Column 1) ===== */\n.nav-rail {\n  width: 56px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: var(--bg-base);\n  border-right: 1px solid var(--glass-border);\n  /* Safe-area top/bottom (status bar / home indicator) padded into the rail\n     so nav buttons never collide with system overlays on iPad/iPhone. */\n  padding-top: max(var(--spacing-sm), env(safe-area-inset-top));\n  padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));\n  z-index: 2;\n}\n\n.nav-rail-top {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  flex: 1;\n  padding-top: var(--spacing-sm);\n}\n\n.nav-rail-bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: var(--spacing-sm);\n}\n\n.nav-btn {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: var(--radius-md);\n  color: var(--text-tertiary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.nav-btn:hover {\n  color: var(--text-secondary);\n  background: var(--bg-hover);\n}\n\n.nav-btn-active {\n  color: var(--color-primary);\n  background: var(--color-primary-dim);\n}\n\n.nav-btn-active::before {\n  content: \"\";\n  position: absolute;\n  left: -8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 20px;\n  background: var(--color-primary);\n  border-radius: 0 var(--radius-xs) var(--radius-xs) 0;\n}\n\n/* Profile avatar in nav rail */\n.nav-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border: 2px solid transparent;\n  object-fit: cover;\n}\n\n.nav-avatar:hover {\n  border-color: var(--glass-highlight);\n}\n\n.nav-avatar-active {\n  border-color: var(--color-primary);\n}\n\n.nav-avatar-initials {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  color: white;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border: 2px solid transparent;\n}\n\n.nav-avatar-initials:hover {\n  border-color: var(--glass-highlight);\n}\n\n.nav-avatar-initials.nav-avatar-active {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 8px var(--color-primary-glow);\n}\n\n/* ===== List Panel (Column 2) ===== */\n.list-panel {\n  width: 280px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-elevated);\n  border-right: 1px solid var(--glass-border);\n  overflow: hidden;\n}\n\n.list-panel-header {\n  flex-shrink: 0;\n  padding: var(--spacing-md) var(--spacing-md) var(--spacing-sm);\n}\n\n.list-panel-title {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  letter-spacing: var(--letter-spacing-tight);\n}\n\n.list-panel-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n/* Scrollbar */\n.list-panel-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.list-panel-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.list-panel-content::-webkit-scrollbar-thumb {\n  background: var(--glass-border);\n  border-radius: var(--radius-full);\n}\n\n.list-panel-content::-webkit-scrollbar-thumb:hover {\n  background: var(--text-tertiary);\n}\n\n/* ===== Main Panel (Column 3) ===== */\n.app-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n/* ===== Mobile Responsive ===== */\n@media (max-width: 768px) {\n  .app-layout {\n    position: relative;\n  }\n\n  .nav-rail {\n    display: none;\n  }\n\n  .list-panel {\n    width: 100%;\n    position: absolute;\n    inset: 0;\n    z-index: 10;\n    transform: translateX(0);\n    transition: transform 0.3s var(--ease-out-expo);\n  }\n\n  .list-panel.list-panel-hidden {\n    transform: translateX(-100%);\n    pointer-events: none;\n  }\n\n  .app-main {\n    width: 100%;\n    position: absolute;\n    inset: 0;\n    transform: translateX(0);\n    transition: transform 0.3s var(--ease-out-expo);\n  }\n\n  .app-main.app-main-hidden {\n    transform: translateX(100%);\n    pointer-events: none;\n  }\n}\n\n/* ===== iPad / Tablet (>= 768px) =====\n   Explicit min-width breakpoint complements the max-width: 768 mobile branch.\n   Three-column layout is the default flex behaviour; this rule re-asserts it\n   for tablets that the max-width rule otherwise wouldn't reach (e.g. iPad\n   portrait at ~820dp, landscape ~1180dp, Stage Manager free windows). */\n@media (min-width: 768px) {\n  .app-layout {\n    position: static;\n  }\n\n  .nav-rail {\n    display: flex;\n  }\n\n  .list-panel {\n    position: static;\n    inset: auto;\n    transform: none;\n    transition: none;\n    z-index: auto;\n  }\n\n  .list-panel.list-panel-hidden {\n    /* On tablets we keep the list panel docked rather than slid off-screen. */\n    transform: none;\n    pointer-events: auto;\n  }\n\n  .app-main {\n    position: static;\n    inset: auto;\n    transform: none;\n    transition: none;\n  }\n\n  .app-main.app-main-hidden {\n    transform: none;\n    pointer-events: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
